import {mapMutations, mapActions, mapGetters} from "vuex";
import { orderTypeHelper } from "../../api/helpers/orderTypeHelper";
import {
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_PICKUP,
  CONSTANT_ORDER_TYPE_DINEIN,
} from "../../constans/strings.js";

export default {
  methods: {
    ...mapMutations([
      "setStore",
      "setSelectedMenuType",
      "setIsDelivery",
      "setIsPickup",
    ]),
    ...mapActions(["initStore"]),
    filterCategory(menu, category) {
      let find = null;
      for (let index = 0; index < menu.Categories.length; index++) {
        const item = menu.Categories[index];
        if (item.Name.toLowerCase() == category.toLowerCase()) {
          find = item;
          break;
        }
      }
      menu.Categories = [find];
      this.storeMenu = menu;
    },
    storeSupportsDelivery: orderTypeHelper.storeSupportsDelivery,
    storeSupportsDinein: orderTypeHelper.storeSupportsDinein,
    storeSupportsPickup: orderTypeHelper.storeSupportsPickup,
    initiateWorkflow() {
      if(this.enabledMultipleMenus) {
        this.showOrderTypeSelection = true;
      } else {
        this.showOrderTypeSelection = false;
        if(!orderTypeHelper.getOrderType()) {
          if(this.storeSupportsPickup(this.selectedCompany)) {
            orderTypeHelper.setOrderTypePickup();
            this.setSelectedMenuType(CONSTANT_ORDER_TYPE_PICKUP);
            this.setIsPickup(true);
          } else if(this.storeSupportsDelivery(this.selectedCompany)) {
            orderTypeHelper.setOrderTypeDelivery();
            this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DELIVERY);
            this.setIsPickup(false);
          } else if(this.storeSupportsDinein(this.selectedCompany)) {
            orderTypeHelper.setOrderTypeDineIn();
            this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DINEIN);
            this.setIsPickup(false);
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters(["hqDoc"]),
    enabledMultipleMenus() {
      return this.selectedCompany
        && this.selectedCompany.ViewComponentConfigs
        && this.selectedCompany.ViewComponentConfigs.MultipleMenus == true;
    },
    isSushiHub() {
      return this.hqDoc && this.hqDoc.IsSushiHub
    }
  },
  watch: {
    enabledMultipleMenus() {
      this.initiateWorkflow();
    },
  },
};
